import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetFailuresPacketRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/GetFailuresPacket`,
	params: { userId, role }
});

export const SetFailurePacketValidInvalidRequest = (userId, id) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Tracker/SetFailurePacketValidInvalid`,
	params: { userId, id }
});

export const GetFailurePacketDetailsRequest = (id, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/GetFailurePacketDetails`,
	params: { id, userId }
});

export const SetFailurePacketDetailsRequest = (trackerPacketDetailsDto, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Tracker/EditFailurePacketDetails`,
	data: { trackerPacketDetailsDto, userId }
});

export const AddPacketCommentRequest = (id, userId, comment) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Tracker/AddFailurePacketComment`,
	params: { id, userId, comment }
});

export const ExportFailuresPacketRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/ExportFailuresPacket`,
	params: { userId, role }
});
